module.exports = __webpack_public_path__ + "img/under-maintenance.4faece37.svg";